import React from 'react'
import Lottie from 'react-lottie';
import * as animationDataWater from "../../plugins/lottie/homepage-water.json";
 
export default class Footlottie extends React.Component {
 
  render() {

    const defaultOptions = {
      loop: true,
      autoplay: true, 
      animationData: animationDataWater.default,
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      }
    };
 
    return <div>
      <Lottie options={defaultOptions} speed={0.3}/>
    </div>
  }
}